import { render, staticRenderFns } from "./EditQuote.vue?vue&type=template&id=46837fe8&scoped=true&"
import script from "./EditQuote.vue?vue&type=script&lang=js&"
export * from "./EditQuote.vue?vue&type=script&lang=js&"
import style0 from "./EditQuote.vue?vue&type=style&index=0&id=46837fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46837fe8",
  null
  
)

export default component.exports